import getComponentName from "./getComponentName";
export default (function (WrappedComponent, hocName) {
  return "".concat(hocName, "(").concat(getComponentName(WrappedComponent), ")");
});